<template>
  <div ref="statusLine" style="height: 100%;">
    <v-card
      v-resize="onResize"
      class="mr-2"
      style="width: 300px; height: 100%; border-radius: 10px"
      fill-height
    >
      <v-card-text ref="statusTitle" class="text-xs-center grey lighten-3">{{value}}</v-card-text>
      <div
        ref="usersContainer"
        style="overflow-y: auto"
        :style="{'height': contentHeight + 'px'}"
        @scroll="onUserScroll"
      >
        <div ref="users">
          <template v-for="(user,index) in users">
            <status-user :value="user" :key="index +'_'+ user.first_name"></status-user>
            <v-divider :key="index +'_'+ user.first_name+'_divider'" v-if="users.length-1 != index"></v-divider>
          </template>
          <div
            v-if="loadmore"
            class="text-xs-center"
            style="background:#eee;padding-top:10px;padding-bottom:10px"
          >
            <v-progress-circular indeterminate color="grey" small class="mr-2" :width="2"></v-progress-circular>Loading
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment'
import api from '@/api'
import { mapGetters } from 'vuex'
import StatusUser from './StatusUser'
import { async } from 'q'
export default {
  props: ['value'],
  data: function() {
    return {
      users: [],
      offset: 0,
      limit: 20,
      loading: true,
      contentHeight: 0,
      loadmore: false,
      hasMore: true,
      maxTime: 15000,
      timer: ''
    }
  },
  components: {
    StatusUser
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted: function() {
    var vm = this
    vm.loading = true
    vm.getQeUsersGroup(0, 20).then(function(users) {
      vm.users = users
      vm.loading = false
    })

    vm.timer = setInterval(vm.getLatestChatUsers, vm.maxTime)
  },
  methods: {
    onUserScroll: function() {
      var vm = this

      let messages = vm.$refs.usersContainer
      let scrollPosition = messages.scrollTop
      let height = messages.clientHeight
      let totalHeight = messages.scrollHeight
      //   console.log(scrollPosition, height, scrollPosition + height, totalHeight)
      if (scrollPosition <= height) {
        vm.isAutoRefresh = true
      }
      if (totalHeight == scrollPosition + height) {
        vm.isAutoRefresh = false
        if (!vm.hasMore) {
          return false
        }
        vm.onLoadmore()
      } else {
        vm.hasMore = true
      }
    },
    onResize: function() {
      this.contentHeight = this.$refs.statusLine.clientHeight - this.$refs.statusTitle.clientHeight
    },
    getLatestUsers: function() {
      var vm = this
      if (vm.loading) {
        return false
      }
      let limit = 20
      if (vm.users.length == 0) {
        limit = 20
      }

      vm.getQeUsersGroup(0, limit).then(
        function(users) {
          vm.users = users
        },
        function(error) {
          // console.log(error)
        }
      )
    },
    getQeUsersGroup: async function(offset, limit) {
      try {
        let response = await api.getQeUsersGroup({
          subject: this.value,
          limit: limit,
          offset: offset
        })
        // console.log(response.data)
        if (response.data) {
          var users = response.data
          users.map(function(el, index) {
            var updatetime = moment(el.updatetime)
            var now = moment()

            if (el.adminupdatetime != null) {
              var adminupdatetime = moment(el.adminupdatetime)

              if (adminupdatetime.diff(updatetime) >= 0) {
                users[index].waitingTime = -1
              } else {
                users[index].waitingTime = now.diff(updatetime, 'seconds')
              }
            } else {
              users[index].waitingTime = now.diff(updatetime, 'seconds')
            }
          })
          users.sort(function(a, b) {
            if (a.waitingTime < b.waitingTime) {
              return 1
            } else if (a.waitingTime > b.waitingTime) {
              return -1
            } else {
              return 0
            }
          })
          return users
        }
      } catch (error) {}
    },
    onLoadmore: async function() {
      var vm = this
      if (vm.loadmore) {
        return false
      }
      vm.loadmore = true
      vm.limit += 5

      try {
        let users = await vm.getQeUsersGroup(vm.offset, vm.limit, false)
        if (users && users.length > 0) {
          vm.users = users
        }
        if (users.length < vm.limit) {
          vm.hasMore = false
        }

        vm.loadmore = false
      } catch (error) {
        vm.loadmore = false
        vm.hasMore = false
      }
    }
  },
  beforeDestroy: function() {
    clearInterval(this.timer)
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/template/qualityexpress/StatusLine.vue